(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name oqs.factory:DataService
   *
   * @description
   *
   */
  angular
    .module('oqs')
    .factory('DataService', DataService);

  DataService.$inject = ['$http', '$log', '_', '$window', 'Blob'];

  function DataService($http, $log, _, $window, Blob) {
    var data = {}
      , DataServiceBase = {
        data: data,
        initialize: initialize,
        getBrokerList: getBrokerList,
        getBroker: getBroker,
        getQuoteType: getQuoteType,
        sendQuoteRequest: sendQuoteRequest,
        sendQuoteConfirmation: sendQuoteConfirmation,
        sendQuoteSummaryEmail: sendQuoteSummaryEmail,
        downloadQuotePdf: downloadQuotePdf,
        getPostalCodeQuestion: getPostalCodeQuestion,
        getQuestionByFlag: getQuestionByFlag,
        addSectionInstance: addSectionInstance,
        clearCache: clearCache,
        formatPostalCode: formatPostalCode,
        formatPhoneNumber: formatPhoneNumber,
        getOptionList: getOptionList,
        emailPattern: '([a-zA-Z0-9_\\-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)',
        phoneNumberPattern: '([0-9]{3}-?[0-9]{3}-?[0-9]{4})',
        getLocaleMessage: getLocaleMessage,
        getSbuWebsite: getSbuWebsite,
        truncateString: truncateString,
        base64StringToBlob: base64StringToBlob
      };

    return DataServiceBase;

    function initialize() {
      // List of the quote types that have been initiated, i.e. their initial default values have been set
      data.initiatedQuoteTypes = [];
      data.useCustomCss = true;
      return $http.get('../../application/quote/definition')
        .then(function (response) {
          $log.debug('Quote definition data is: ' + angular.toJson(response.data));
          data.quoteDefinition = response.data;
          createViewModel();
          data.quoteRequest = {};
        }, function (response) {
          $log.error('XHR failed for quote definition with data: ' + response.data);
        });
    }

    function getBrokerList(postalCode) {
      data.brokerListRequestInProgress = true;
      if (angular.isDefined(data.brokerList) && angular.isDefined(data.brokerList.brokers)) {
        data.brokerList.brokers = [];
      }
      return $http.get('../../application/brokers?postalCode=' + postalCode)
        .then(function (response) {
          $log.debug('Broker list data for ' + postalCode + ' is: ' + angular.toJson(response.data));
          data.brokerList = response.data;
          enrichBrokerData();
          data.brokerListRequestInProgress = false;
        }, function (response) {
          $log.error('XHR failed for quote definition with data: ' + response.data);
          data.brokerListRequestInProgress = false;
        }
        );
    }

    function getBroker(brokerRef) {
      return $http.get('../../application/brokers/' + brokerRef)
        .then(function (response) {
          if (angular.isObject(response.data)) {
            $log.debug('Broker for ref ' + brokerRef + ' is: ' + angular.toJson(response.data));
            data.selectedBroker = response.data;
          } else {
            $log.debug('No broker found for ref ' + brokerRef);
          }
        }, function (response) {
          $log.error('XHR failed for broker request with data: ' + response.data);
        });
    }

    function getOptionList(question) {
      return $http.get(question.optionListUrl)
        .then(function (response) {
          $log.debug('Option list data response: ' + angular.toJson(response));
          question.optionList = response.data;
        }, function (response) {
          $log.error('XHR failed for get option list with data: ' + response.data);
        });
    }

    function getQuoteType(quoteTypeId) {
      return _.find(data.quoteDefinition.quoteTypeList, function (quoteType) {
        return quoteType.id === quoteTypeId;
      });
    }

    function sendQuoteConfirmation(contactInfo) {
      data.quoteRequest.selectedBroker = data.selectedBroker;
      data.quoteRequest.contactInfo = contactInfo;
      data.quoteConfirmationInProgress = true;
      return $http.post('../../application/quote/confirmation', data.quoteRequest)
        .then(function (response) {
          $log.debug('Quote ID is: ' + response.data.quoteConfirmationId);
          data.quoteConfirmationResponse = response;
        }, function (response) {
          $log.error('XHR failed for quote request with data: ' + response.data);
          data.quoteConfirmationResponse = response;
        }).then(function () {
          data.quoteConfirmationInProgress = false;
        });
    }

    function sendQuoteSummaryEmail(contactInfo) {
      data.quoteRequest.selectedBroker = data.selectedBroker;
      data.quoteRequest.contactInfo = contactInfo;
      return $http.post('../../application/quote/send', data.quoteRequest)
        .then(function (response) {
          $log.debug('Quote request send summary response is: ' + angular.toJson(response.data));
          data.quoteSummaryEmailResponse = response;
        }, function (response) {
          $log.error('XHR failed for quote request with data: ' + response.data);
          data.quoteSummaryEmailResponse = response;
        });
    }

    function downloadQuotePdf() {
      data.quoteRequest.selectedBroker = data.selectedBroker;
      data.quoteRequest.contactInfo = {
        name: getQuestionByFlag('name').answer
      };
      return $http.post('../../application/quote/download', data.quoteRequest)
        .then(function (response) {
          $log.debug('Quote download request success. Filename is ' + response.data.quoteFileName);
          return response;
        }, function (response) {
          $log.error('XHR failed for download pdf request with data: ' + response.data);
        });
    }

    function createAnswerListFromSectionInstance(sectionInstance) {
      var answerList = []
        , displayValue
        , selectedOption;
      _.forEach(sectionInstance.questionList, function (question) {
        selectedOption = null;
        if (question.answer !== null && question.optionList) {
          selectedOption = _.find(question.optionList, function (option) {
            return question.answer === option.value;
          });
        }
        if (selectedOption) {
          displayValue = selectedOption.name;
        } else {
          displayValue = question.answer;
        }
        answerList.push({
          questionId: question.definition.id,
          value: question.answer,
          displayValue: displayValue
        });
      });
      return answerList;
    }

    function sendQuoteRequest() {
      $log.debug('Sending a quote request.');
      data.quoteRequestInProgress = true;
      data.quoteRequest.quoteTypeId = data.viewModel.selectedQuoteType.definition.id;
      data.quoteRequest.answerSectionList = [];
      _.forEach(data.viewModel.sectionList, function (section) {
        _.forEach(section.instanceList, function (instance) {
          data.quoteRequest.answerSectionList.push({
            questionSectionId: section.definition.id,
            answerList: createAnswerListFromSectionInstance(instance)
          });
        });
      });
      _.forEach(data.viewModel.selectedQuoteType.sectionList, function (section) {
        _.forEach(section.instanceList, function (instance) {
          data.quoteRequest.answerSectionList.push({
            questionSectionId: section.definition.id,
            answerList: createAnswerListFromSectionInstance(instance)
          });
        });
      });
      data.quoteResponse = {};

      return $http.post('../../application/quote', data.quoteRequest)
        .then(function (response) {
          $log.debug('Quote request response is: ' + angular.toJson(response.data));
          data.quoteResponse = response;
        }, function (response) {
          $log.error('XHR failed for quote request with data: ' + response.data);
          data.quoteResponse.error = response;
        })
        .then(function () {
          data.quoteRequestInProgress = false;
        });
    }

    function clearCache() {
      return $http.post('../../configuration/clearCache', '')
        .then(function (response) {
          $log.debug('Cache clear request success.');
          data.cacheClearResponse = response.data;
          $window.location.reload();
        }, function (response) {
          $log.error('Cache clear request error with data: ' + response.data);
          data.cacheClearResponse = response.data;
        });
    }

    function createViewModel() {
      $log.debug('Creating the viewModel from the definition data.');
      data.viewModel = {
        sectionList: [],
        quoteTypeList: [],
        selectedQuoteType: null
      };
      _.forEach(data.quoteDefinition.questionSectionList, function (questionSection) {
        data.viewModel.sectionList.push({
          definition: questionSection,
          instanceList: [createSectionInstance(questionSection)]
        });
      });
      _.forEach(data.quoteDefinition.quoteTypeList, function (quoteTypeDefinition) {
        data.viewModel.quoteTypeList.push({
          definition: quoteTypeDefinition,
          sectionList: []
        });
      });
      _.forEach(data.viewModel.quoteTypeList, function (quoteType) {
        _.forEach(quoteType.definition.questionSectionList, function (questionSection) {
          quoteType.sectionList.push({
            definition: questionSection,
            instanceList: [createSectionInstance(questionSection)]
          });
        });
      });
    }

    function getNextAvailableId(sectionInstanceList) {
      var id;
      for (id = 0; ;id++) {
        if (_.findIndex(sectionInstanceList, {id: id}) < 0) {
          return id;
        }
      }
    }

    function addSectionInstance(section) {
      section.instanceList.push(createSectionInstance(section));
    }

    function createSectionInstance(section) {
      var questionInstanceList = [],
          sectionInstance = {},
          sectionDefinition = section.definition ? section.definition : section,
          questionList = sectionDefinition.questionList,
          newId = getNextAvailableId(section.instanceList),
          headingQuestionName = sectionDefinition.attributes.headingQuestion,
          defaultHeading = sectionDefinition.attributes.heading + ' ' + (newId + 1);

      sectionInstance.getHeading = function () {
        var headingQuestion = null;
        if (headingQuestionName) {
          headingQuestion = findQuestionByNameInSection(headingQuestionName, sectionInstance);
        }
        if (headingQuestion && headingQuestion.answer !== null &&
          angular.isDefined(headingQuestion.answer) &&
          headingQuestion.answer) {
          return headingQuestion.answer;
        }
        return defaultHeading;
      };
      sectionInstance.id = newId;
      _.forEach(questionList, function (question) {
        questionInstanceList.push({
          definition: question,
          answer: question.defaultValue,
          sectionInstanceId: questionInstanceList.length
        });
      });
      sectionInstance.questionList = questionInstanceList;
      return sectionInstance;
    }

    function getPostalCodeQuestion() {
      return _.find(data.viewModel.sectionList[0].instanceList[0].questionList, function (question) {
        return question.definition.attributes.control === 'postalcode';
      });
    }

    function getQuestionByFlag(flagValue) {
      return _.find(data.viewModel.sectionList[0].instanceList[0].questionList, function (question) {
        return _.includes(question.definition.attributes, flagValue);
      });
    }

    function enrichBrokerData() {
      _.forEach(data.brokerList.brokers, function (broker, index) {
        broker.pinLabel = String.fromCharCode('A'.charCodeAt(0) + index);
        broker.icon = 'https://maps.google.com/mapfiles/marker' + broker.pinLabel + '.png';
      });
    }

    function formatPostalCode(inPostalCode) {
      var retVal = inPostalCode;
      if (retVal) {
        if (retVal.indexOf(' ') !== 3) {
          retVal = retVal.slice(0, 3) + ' ' + retVal.slice(3);
        }
        retVal = retVal.toUpperCase();
      }
      return retVal;
    }

    function formatPhoneNumber(inPhoneNumber) {
      var retVal = inPhoneNumber;
      $log.debug('Formatting phone number ' + inPhoneNumber);
      if (retVal) {
        if (retVal.charAt(3) !== '-') {
          retVal = retVal.slice(0, 3) + '-' + retVal.slice(3);
        }
        if (retVal.charAt(7) !== '-') {
          retVal = retVal.slice(0, 7) + '-' + retVal.slice(7);
        }
      }
      return retVal;
    }

    function getLocaleMessage(messageKey) {
      if (data.quoteDefinition) {
        return data.quoteDefinition.localeMessages[messageKey];
      }
      return null;
    }

    function getSbuWebsite() {
      var sbuWebsite = null;
      if (data.quoteDefinition) {
        sbuWebsite = data.quoteDefinition.sbuDetails.website;
        if (sbuWebsite &&
          sbuWebsite.indexOf('http://') === -1 &&
          sbuWebsite.indexOf('https://') === -1) {
          sbuWebsite = 'http://' + sbuWebsite;
        }
      }
      return sbuWebsite;
    }

    function findQuestionByNameInSection(questionName, section) {
      return _.find(section.questionList, function (question) {
        return question.definition.name === questionName;
      });
    }

    function truncateString(str, max) {
      return str.length > max ? str.substring(0, max - 3) + '...' : str;
    }

    // Code adapted from http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
    function base64StringToBlob(base64String, contentType, sliceSize) {
      var byteCharacters = $window.atob(base64String),
          byteArrays = [],
          slice,
          byteNumbers,
          byteArray,
          retBlob,
          offset,
          i;
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      for (offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        slice = byteCharacters.slice(offset, offset + sliceSize);
        byteNumbers = new Array(slice.length);
        for (i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      retBlob = new Blob(byteArrays, {type: contentType});
      return retBlob;
    }
  }
}());
